<template>
    <section>
        {{$route.params}} <br>        
        {{$route.query}}
    </section>
</template>

<script>
/**
 * 단독 시험 다이나믹 링크 브릿지 컴포넌트(independant exam dynamic link bridge component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {dynamicMixin} from '@/mixins/dynamic.js'

export default {
    mixins: [dynamicMixin],
    async mounted() {
        this.$showLoading()

        // 브랜드 정보/언어 설정(set brand & language)
        await this.setBrandInfo()

        let loginPath = `/login?redirectPath=${encodeURIComponent(this.$route.path)}`
        let distId = this.$route.params.distId

        //로그인 체크(check auth token)
        await this.checkLogin().then(() => {
            let params = {
                 distId: distId
            }
            //응시 이력 조회(Examinations history check)
            examApi.dynamic(params).then((response) => {
                
                if (response.data.data) {
                    // move Independent Exam My View
                    this.$router.push({
                        name: 'IndependentExamMyView',
                        params: {
                            examineeId: response.data.data
                        },
                        query: {
                            listType: 'my'
                        }
                    })
                }else {
                    // move Independent Exam total View           
                    this.$router.push({
                        name: 'IndependentExamTotalView',
                        params: {
                            distId: distId
                        },
                        query: {
                            listType: 'total'
                        }
                    })
                }
            }).catch((err) => {
                // when error, move Independent Exam total list      
                 this.$router.push({
                    name: 'IndependentExam',
                    query: {
                        listType: 'total'
                    }
                })
            })
            
        }).catch(() => {
            // move sign in
            this.$router.push(loginPath)
        })
        
        setTimeout(() => {
            this.$hideLoading()
        }, 1000)

        
    },

}
</script>